import { Box, Container, Heading, Image, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { CtaButton } from '../components/CtaButton';

const POINTS = [
  { key: 'personalUse', icon: '/images/landing/cmp-icon-1.png' },
  { key: 'nonCompliant', icon: '/images/landing/cmp-icon-2.png' },
  { key: 'noControl', icon: '/images/landing/cmp-icon-3.png' },
] as const;

function CompareCard({ icon, text }: { icon: string; text: string }) {
  return (
    <Stack
      bg="white"
      borderRadius="20px"
      px="32px"
      py="28px"
      align="center"
      spacing="18px"
      minH="156px"
      boxShadow="0 8px 24px rgba(39,13,23,0.06)"
    >
      <Image src={icon} alt="" w="44px" h="44px" />
      <Text fontSize="md" fontWeight={600} color="onboarding.deepPlum" textAlign="center">
        {text}
      </Text>
    </Stack>
  );
}

export function Comparison() {
  const { t } = useTranslation();
  return (
    <Box as="section" id="comparison" bg="white">
      <Container maxW="1188px" py={{ base: 16, lg: 24 }}>
        <Stack spacing="10px" textAlign="center" align="center" mb={{ base: 10, lg: '50px' }}>
          <Heading
            as="h2"
            fontFamily="heading"
            fontWeight={700}
            fontSize="display.lg"
            lineHeight={1.1}
            letterSpacing="-0.01em"
            color="onboarding.deepPlum"
          >
            {t('landing.comparison.title')}
          </Heading>
          <Text fontSize="md" color="onboarding.deepPlum">
            {t('landing.comparison.intro')}
          </Text>
        </Stack>

        <SimpleGrid columns={{ base: 1, md: 3 }} spacing="21px">
          {POINTS.map((p) => (
            <CompareCard key={p.key} icon={p.icon} text={t(`landing.comparison.points.${p.key}`)} />
          ))}
        </SimpleGrid>

        <Stack
          mt={{ base: 10, lg: '50px' }}
          position="relative"
          overflow="hidden"
          bg="onboarding.deepPlum"
          borderRadius="20px"
          align="center"
          spacing="24px"
          py={{ base: 12, lg: '64px' }}
          px={6}
        >
          <Box
            position="absolute"
            inset={0}
            bgImage="url(/images/landing/cmp-banner-bg.png)"
            bgSize="cover"
            bgPosition="center"
            pointerEvents="none"
          />
          <Image
            src="/images/landing/cmp-logo.png"
            alt="Streamko"
            h={{ base: '40px', md: '52px' }}
            position="relative"
            draggable={false}
          />
          <Text
            position="relative"
            fontSize={{ base: 'xl', md: 'display.sm' }}
            fontWeight={400}
            color="white"
            textAlign="center"
            maxW="900px"
          >
            {t('landing.comparison.banner')}
          </Text>
          <CtaButton
            to="/onboarding"
            position="relative"
            bg="onboarding.cream"
            color="onboarding.plum"
            borderRadius="pill"
            height="48px"
            px="28px"
            fontSize="md"
            fontWeight={600}
            _hover={{ bg: 'white' }}
            withArrow
            trackEventName="cta_click"
            trackProps={{ section: 'comparison' }}
          >
            {t('landing.comparison.cta')}
          </CtaButton>
        </Stack>
      </Container>
    </Box>
  );
}
